import { render, staticRenderFns } from "./Traveler.vue?vue&type=template&id=63bd11ac&scoped=true&"
import script from "./Traveler.vue?vue&type=script&lang=js&"
export * from "./Traveler.vue?vue&type=script&lang=js&"
import style0 from "./Traveler.vue?vue&type=style&index=0&id=63bd11ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd11ac",
  null
  
)

export default component.exports